import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import useKeyPress from '../../../../hooks/useKeyPress';
import { setCurrentListBoundaries } from "../../../../actions/index";

let holdTimeout = null;
function ConnectedArrowsManager({
  id, items, onSelect, isReduce,
  api, isConnected, selectedItems, dimension, setCurrentListBoundaries
}) {
  const { height } = dimension;
  const keyLeft = useKeyPress('ArrowLeft', false, false, false, true, true);
  const keyRight = useKeyPress('ArrowRight', false, false, false, true, true);
  const keyDown = useKeyPress('ArrowDown', true);
  const keyUp = useKeyPress('ArrowUp', true);
  const [boundaries, setBoundaries] = useState({ top: null, bottom: null });
  const [isHold, setHold] = useState(false)

  const keyQ = null;// useKeyPress('Q', false, false, false, true); //PREV Deck 1
  const keyA = null;// useKeyPress('A', false, false, false, true); //PREV Deck 2
  const keyW = null;// useKeyPress('W', false, false, false, true); //NEXT Deck 1
  const keyS = null;// useKeyPress('S', false, false, false, true); //NEXT Deck 2

  useEffect(() => {
    const x = document.getElementById(`FSL-${id}`).getBoundingClientRect();
    const headerBottom = document.getElementById(`headerPartial`) ? document.getElementById(`headerPartial`).getBoundingClientRect().bottom : 0; // Touch - Auto Scroll + DnD
    const b = { top: x.top - (isReduce ? 65 : 0), bottom: window.innerHeight, t: headerBottom, b: x.bottom };
    setBoundaries(b);
    setCurrentListBoundaries(b);
  }, [height, id, isReduce, setCurrentListBoundaries]);

  useEffect(() => {
    clearTimeout(holdTimeout);

    if (selectedItems.length === 1 && selectedItems[0].listParentId === id) {
      if (keyUp || keyDown || keyQ || keyA || keyW || keyS) { // NAVIGATE
        let actualIndex =  items.findIndex( x => x.id === selectedItems[0].id && x.selected ) ;
        if (keyUp || keyQ || keyA) { actualIndex -= 1 } else if (keyDown || keyW || keyS) { actualIndex += 1 }
        if (items[actualIndex]) {
          onSelect(items[actualIndex], {}, actualIndex);
          const el = document.getElementsByClassName(`item`)[actualIndex];
          if (el) {
            const elementRect = el.getBoundingClientRect();
            // console.log(elementRect.top, boundaries.top, elementRect.bottom, boundaries.bottom);
            if ((elementRect.top > 0 && elementRect.top < boundaries.top) || (elementRect.bottom > 0 && elementRect.bottom > boundaries.bottom)) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
              })
            }
          }

          if (keyW || keyS || keyQ || keyA) { // COMBINAISON
            const item = items[actualIndex];
            if (document.getElementById(`${keyW || keyQ ? `L` : `R`}-PMB-${item.id}`)) {
              document.getElementById(`${keyW || keyQ ? `L` : `R`}-PMB-${item.id}`).click();
            }
          }

        }
        holdTimeout = setTimeout( () => { setHold(new Date()) }, 250);
      }
      if (keyRight || keyLeft) { // LOAD PLAYER
        const item = items.find( x => x.id === selectedItems[0].id );
        if (document.getElementById(`${keyRight ? `R` : `L`}-PMB-${item.id}`)) {
          document.getElementById(`${keyRight ? `R` : `L`}-PMB-${item.id}`).click();
        }
      }
    } else if ( keyRight || keyLeft ) { // IN CASE NOT IN CACHE/REDUX BUT STILL SELECTED
      const selected = document.querySelector(`.item.selected .pmb-${keyRight ? `b` : `a`}`);
      if (selected) {
        selected.click();
        api.getFromYD(`/tracking-error-api.php`, { url: 'NC CONTROL', message: `Error - ${selected ? selected.id : 'NO_ID'}`, res: 'library', status: '500' });
      }      
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyDown, keyUp, keyLeft, keyRight, isHold, onSelect, boundaries, keyW, keyS, keyQ, keyA ]) //Warning -  items and selectItems has to be unique

  return null;
}

ConnectedArrowsManager.propTypes = {
  id: PropTypes.any.isRequired,
  items: PropTypes.array.isRequired,
  isReduce: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
}

const ArrowsManager = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    selectedItems: state.selectedItems,
    dimension: state.dimension
  }),
  dispatch => ({
    setCurrentListBoundaries: (boundaries) => dispatch(setCurrentListBoundaries(boundaries)),
  })
)(ConnectedArrowsManager);

export default ArrowsManager;
